import { render } from "./sidebar.vue?vue&type=template&id=7c26d9ca&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=7c26d9ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/faber-mieruca-connect/faber-mieruca-connect/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c26d9ca"]])

export default __exports__